// extracted by mini-css-extract-plugin
export default {"root":"Text_root__CcGIi","xs":"Text_xs__ymNIq","sm":"Text_sm__6G7ZX","md":"Text_md__ZtVe6","lg":"Text_lg__F8dev","xl":"Text_xl__tZREr","xxl":"Text_xxl__p-wFP"};